import styled, { css } from 'styled-components';

type ContainerProps = {
  isDragging: boolean;
  hasError: boolean;
};

type ImageProps = {
  placeholder: string;
  url: string;
};

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  > label {
    display: block;
    color: #101d40;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 6px;
    font-family: 'Sora', sans-serif;
  }
`;

export const ManagePreviewImage = styled.div`
  display: flex;
  position: absolute;
  height: 50px;
  width: 100%;
  background-color: #ff5500;
  bottom: 0;
  left: 0;
  border-radius: 0px 0px 5px 5px;
  transform: translateY(50px);
  transition: all 0.2s ease-in-out;

  button {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    svg {
      font-size: 25px;
    }
  }

  button:first-child {
    background-color: #ebf5ff;

    svg {
      color: #329bfc;
    }

    &:hover {
      background-color: #d6eaff;
    }
  }

  button:last-child {
    background-color: #ffecec;

    svg {
      color: #f64444;
    }

    &:hover {
      background-color: #ffd6d6;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  svg {
    color: #329bfc;

    :not(:only-child) {
      margin-bottom: 15px;
    }
  }

  p {
    color: #101d40;
    font-family: 'Sora', sans-serif;
    font-size: 16px;
    font-weight: 500;
    text-align: center;

    & + span {
      margin-top: 8px;
    }
  }

  span {
    font-family: 'Sora', sans-serif;
    color: #8f95a5;
    font-size: 14px;
    text-align: center;
  }
`;

export const Container = styled.div<ContainerProps>`
  display: flex;
  position: relative;
  border: 2px dashed #e6effb;
  background-color: #fafcff;
  border-radius: 5px;
  overflow: hidden;
  flex: 1;
  transition: all 0.2s ease-in-out;

  input[type='file'] {
    display: none;
  }

  label {
    position: absolute;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;

    & ~ label,
    & ~ div {
      display: none;
    }
  }

  &:hover {
    border-color: #329bfc;

    & > ${ManagePreviewImage} {
      transform: translateY(0px);
    }
  }

  ${({ isDragging }) =>
    isDragging &&
    css`
      border-color: #329bfc;
      background-color: #ebf5ff;
    `};

  ${({ hasError }) =>
    hasError &&
    css`
      border-color: #f64444;
      background-color: #ffe8e8;

      ${Content} > svg {
        color: #f64444;
      }
    `}
`;

export const Image = styled.div<ImageProps>`
  background-image: url(${({ placeholder }) => placeholder});
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 18px;
  width: 50px;
  min-width: 50px;
  height: 50px;
  border: 2px dashed #e6effb;
  border-radius: 5px;
  background-size: cover;

  div {
    height: 50px;
    width: 100%;

    background-image: url(${({ url }) => url}), url(${({ url }) => url});
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }
`;
